import { createRouter, createWebHistory, type RouteRecordRaw, START_LOCATION } from "vue-router";

import { consumeBackNavigation, pushRoute } from "./historyStack";

import { STORAGE_KEY } from "@/constants/storage";
import { authService } from "@/shared/auth/services/authService";
import { storage } from "@/utils/storage";
const routes: RouteRecordRaw[] = [
  // 로그인
  {
    path: "/auth/login",
    name: "AuthLogin",
    component: () => import(`@/pages/LoginView.vue`),
  },
  // 소셜로그인 콜백
  {
    path: "/auth/social-callback/:provider",
    name: "AuthSocialCallback",
    component: () => import(`@/pages/SocialLoginCallBack.vue`),
  },
  // 이용약관 동의
  {
    path: "/auth/terms",
    name: "AuthTerms",
    component: () => import(`@/pages/TermsView.vue`),
  },
  // 로그인/회원가입 완료
  {
    path: "/auth/complete/:type",
    name: "AuthComplete",
    component: () => import(`@/pages/AuthComplete.vue`),
  },
  // WebView
  {
    path: "/wv",
    component: () => import(`@/layouts/WebViewLayout.vue`),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "exchange",
        name: "Exchange",
        component: () => import(`@/pages/webView/ExchangeView.vue`),
        meta: {
          showHeader: true,
          header: {
            title: "교환소",
          },
        },
      },
      {
        path: "goods/:id",
        name: "GoodsDetail",
        component: () => import(`@/pages/webView/GoodsDetailPage.vue`),
        meta: {
          showHeader: true,
          header: {
            title: "상품 정보",
          },
        },
      },
      {
        path: "point-history",
        name: "PointHistory",
        component: () => import(`@/pages/webView/PointHistoryView.vue`),
        meta: {
          showHeader: true,
          header: {
            title: "포인트 내역",
          },
        },
      },
      {
        path: "offerwall",
        name: "OfferWall",
        component: () => import(`@/pages/webView/OfferwallView.vue`),
        meta: {
          showHeader: false,
          header: {
            title: "오퍼월",
          },
        },
      },
      {
        path: "goods/:id/exchange",
        name: "GoodsExchange",
        component: () => import(`@/pages/webView/GoodsExchange.vue`),
        meta: {
          showHeader: true,
          header: {
            title: "상품 교환",
          },
        },
      },
      {
        path: "jackpot",
        name: "Jackpot",
        component: () => import(`@/pages/webView/JackpotPage.vue`),
        meta: {
          showHeader: true,
          header: {
            title: "래디오 잭팟",
          },
        },
      },
      {
        path: "invite",
        name: "Invite",
        component: () => import(`@/pages/webView/InviteView.vue`),
        meta: {
          showHeader: true,
          header: {
            title: "친구 초대 이벤트",
          },
        },
      },
    ],
  },
  // Kakao
  {
    path: "/kakao/open/:code",
    name: "KakaoShare",
    component: () => import(`@/pages/kakao/KakaoShareOpenPage.vue`),
  },
  // Download
  {
    path: "/download",
    name: "Download",
    component: () => import(`@/pages/DownloadPage.vue`),
  },
  // AdDownload
  {
    path: "/ad-download",
    name: "AdDownload",
    component: () => import(`@/pages/AdDownLoad.vue`),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, _, next) => {
  /**
   * 인증 필요 페이지가 아니면 통과
   */
  if (!to.meta.requiresAuth) {
    return next();
  }

  try {
    const bridgeResponse = await authService.getAuthInfo();
    storage.set(STORAGE_KEY.ACCESS_TOKEN, bridgeResponse.result.accessToken);
    storage.set(STORAGE_KEY.REFRESH_TOKEN, bridgeResponse.result.refreshToken);
    storage.set(STORAGE_KEY.USER_ID, bridgeResponse.result.userId);
    next();
  } catch (error) {
    console.error("[router error]", error);
  }
});

router.afterEach((_, from) => {
  if (from === START_LOCATION) return;

  if (consumeBackNavigation()) return;
  pushRoute(from.fullPath);
});

export default router;
